import { render, staticRenderFns } from "./DynamicDataFieldText.vue?vue&type=template&id=836f1b22&"
import script from "./DynamicDataFieldText.vue?vue&type=script&lang=ts&"
export * from "./DynamicDataFieldText.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicDataFieldText.vue?vue&type=style&index=0&id=836f1b22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports